<template>
  <v-dialog
      v-model="dialog"
      :scrollable="true"
      width="750">
    <template v-slot:activator="{ on, attrs }">
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card
            elevation="3"
            video
            >
            <v-img
                :lazy-src="`https://img.youtube.com/vi/${id}/default.jpg`"
                :src="`https://img.youtube.com/vi/${id}/hqdefault.jpg`"
                aspect-ratio="1.8"
                class="grey lighten-2">
              <template v-slot:placeholder>
                <v-row
                    align="center"
                    class="fill-height ma-0"
                    justify="center">
                  <v-progress-circular
                      color="grey lighten-5"
                      indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-title
              class="title">
                {{ title }}
            </v-card-title>

            <v-fade-transition>
              <v-overlay
                  v-if="hover"
                  absolute
                  color="tracefyBlue">
                <v-btn v-bind="attrs" v-on="on">View</v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
    </template>

    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>
        <iframe v-if="dialog" :src="`https://www.youtube.com/embed/${id}?autoplay=1&origin=https://portal.tracefy.com`"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                frameborder="0"
                height="395"
                type="text/html"
                width="100%"></iframe>
      </v-card-text>

      <v-card-text v-if="showLink">
        <b>PROMO LINK: </b><br/>
        <h2>https://www.youtube.com/embed/{{this.id}}</h2>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Video',
  props: {
    id: String,
    title: String
  },
  computed: {
    showLink () {
      return this.title?.includes('promo') || false
    }
  },
  data () {
    return {
      dialog: false
    }
  }
}
</script>
